import PropTypes from 'prop-types';
import React from 'react';

import { translate as t } from '../../lib/I18n';

import Icon from '../general/Icon';

export default function StationFinderToggle({ onActivate }) {
    return (
        <button onClick={ onActivate } className="btn btn-default stationFinder__open">
            <Icon icon="search" />
            { t('stationFinder.modal.link') }
        </button>
    );
}

StationFinderToggle.propTypes = {
    onActivate: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/stationFinder/StationFinderToggle.js